import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@environments/environment'
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiResult} from '../../../shared/model/Index';
import { ICorrespondence } from '../../prospective/model/correspondence';
import { Guid } from 'guid-typescript';


@Injectable({ providedIn: 'root' })

export class CorrespondenceService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    getCorrespondenceById(studentId:Guid) {
        return this.http.get<ApiResult<ICorrespondence[]>>(env.apiUrl + 'correspondence/' + studentId).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }

    downloadCorrespondence(studentCorrespondanceId: Guid,studentId: Guid) {
        return this.http.get(env.apiUrl + 'correspondence/downloadfile/'+studentId+'/'+studentCorrespondanceId, {
            responseType: 'blob'
        });
    } 
}